import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationComponent } from './application/application.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { QuoteComponent } from './quote/quote.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { PaymentComponent } from './payment/payment.component';
import { SignComponent } from './sign/sign.component';
import { FinalPageComponent } from './final-page/final-page.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/landing-page', pathMatch: 'full' },
  { path: 'landing-page', component: LandingPageComponent },
  { path: 'application', component: ApplicationComponent },
  { path: 'login', component: ApplicationComponent },
  { path: 'questionnaire', component: QuestionnaireComponent, canActivate: [AuthGuard] }, // Protected
  { path: 'quote', component: QuoteComponent, canActivate: [AuthGuard] }, // Protected
  { path: 'payment', component: PaymentComponent, canActivate: [AuthGuard] }, // Protected
  { path: 'sign', component: SignComponent, canActivate: [AuthGuard] }, // Protected
  { path: 'receipt', component: FinalPageComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }